import {FLAG_RADIUS, FLAG_Y} from "@/components/panes/components/timeline/utilities/render-utilities";
import {searchForCue} from "@user-interface/glim-player/lib/services/metadata.service";

export function getNielsenFlags(cues, start, end, context,metadataCues){
  let flags = [];
  cues.forEach(cue => {
    if (cue.startTime >= start && cue.startTime <= end && cue.value.meter && cue.value.meter.nielsen) {
      let metadataCue = searchForCue(metadataCues, cue.startTime);
      if (!metadataCue) return;
      let startTime = metadataCue.startTime;
      let endTime = metadataCue.endTime;
      const offsetMultiplier = (context.canvas.width / (end - start));
      let positionInTheMiddleOfTheFrame = (startTime - start) + (endTime - startTime) / 2;
      let x = positionInTheMiddleOfTheFrame * offsetMultiplier;
      flags.push({
        x:        x-FLAG_RADIUS,
        y:        0,
        width:    FLAG_RADIUS*2,
        height:   FLAG_RADIUS*2 + FLAG_Y,
        position: (endTime - startTime)/2 + startTime
      })
    }
  })
  return flags;
}

export function getMetadataFlags(cues, start, end, context){
  let flags = [];
  cues.forEach(cue => {
    if (cue.startTime >= start && cue.startTime <= end && (cue.value.info.hasScte35 || cue.value.info.hasScte104)) {
      const offsetMultiplier = (context.canvas.width / (end - start));
      let positionInTheMiddleOfTheFrame = (cue.startTime - start) + (cue.endTime - cue.startTime) / 2;
      let x = positionInTheMiddleOfTheFrame * offsetMultiplier;
      flags.push({
        x:        x-FLAG_RADIUS,
        y:        FLAG_Y,
        width:    FLAG_RADIUS*2,
        height:   FLAG_RADIUS*2 + FLAG_Y,
        position: (cue.endTime - cue.startTime)/2 + cue.startTime
      })
    }
  })
  return flags
}

function area(x1, y1, x2, y2, x3, y3) {
  return Math.abs((x1 * (y2 - y3) + x2 * (y3 - y1) + x3 * (y1 - y2)) / 2.0);
}

/* A function to check whether point P(x, y) lies inside the triangle formed
by A(x1, y1), B(x2, y2) and C(x3, y3) */
export function isInsideTriangle(x1, y1, x2, y2, x3, y3, x, y) {
  /* Calculate area of triangle ABC */
  let A = area(x1, y1, x2, y2, x3, y3);

  /* Calculate area of triangle PBC */
  let A1 = area(x, y, x2, y2, x3, y3);

  /* Calculate area of triangle PAC */
  let A2 = area(x1, y1, x, y, x3, y3);

  /* Calculate area of triangle PAB */
  let A3 = area(x1, y1, x2, y2, x, y);

  /* Check if sum of A1, A2 and A3 is same as A */
  return (A === A1 + A2 + A3);
}

export function isInsideRectangle(leftTopX, leftTopY, width, height, clickX, clickY) {
  return clickX >= leftTopX && clickX <= (leftTopX + width) && clickY >= leftTopY && clickY <= (leftTopY + height);
}
